// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jsonEditorContainer {
  line-height: 1;
  font-size: 12px;
}
.jsonEditorContainer .objectContent,
.jsonEditorContainer .arrayContent {
  position: relative;
}
.jsonEditorContainer .objectContent .jsonKey,
.jsonEditorContainer .arrayContent .jsonKey,
.jsonEditorContainer .objectContent .jsonValue,
.jsonEditorContainer .arrayContent .jsonValue {
  margin-right: 10px;
}
.jsonEditorContainer .objectContent .arrayContent,
.jsonEditorContainer .arrayContent .arrayContent {
  margin-left: 20px;
}
.jsonEditorContainer .indexLine {
  position: relative;
  margin-bottom: 5px;
}
.jsonEditorContainer .tools {
  position: absolute;
  right: 0;
  top: 0;
}
.jsonEditorContainer .tools .iconSubtraction {
  margin-left: 10px;
}
.jsonEditorContainer .addItem {
  display: flex;
  margin-top: 10px;
}
.jsonEditorContainer .mt15 {
  display: inline-block;
  margin-top: 7px;
}
.jsonEditorContainer .collapse {
  position: relative;
}
.jsonEditorContainer .collapse.down {
  transition: transform 0.2s ease;
  transform: rotate(270deg);
}
.jsonEditorContainer .collapse.up {
  transition: transform 0.2s ease;
  transform: rotate(360deg);
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-json-editor-ui/dist/react-json-editor-ui.cjs.development.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,kBAAkB;AACpB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B","sourcesContent":[".jsonEditorContainer {\n  line-height: 1;\n  font-size: 12px;\n}\n.jsonEditorContainer .objectContent,\n.jsonEditorContainer .arrayContent {\n  position: relative;\n}\n.jsonEditorContainer .objectContent .jsonKey,\n.jsonEditorContainer .arrayContent .jsonKey,\n.jsonEditorContainer .objectContent .jsonValue,\n.jsonEditorContainer .arrayContent .jsonValue {\n  margin-right: 10px;\n}\n.jsonEditorContainer .objectContent .arrayContent,\n.jsonEditorContainer .arrayContent .arrayContent {\n  margin-left: 20px;\n}\n.jsonEditorContainer .indexLine {\n  position: relative;\n  margin-bottom: 5px;\n}\n.jsonEditorContainer .tools {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.jsonEditorContainer .tools .iconSubtraction {\n  margin-left: 10px;\n}\n.jsonEditorContainer .addItem {\n  display: flex;\n  margin-top: 10px;\n}\n.jsonEditorContainer .mt15 {\n  display: inline-block;\n  margin-top: 7px;\n}\n.jsonEditorContainer .collapse {\n  position: relative;\n}\n.jsonEditorContainer .collapse.down {\n  transition: transform 0.2s ease;\n  transform: rotate(270deg);\n}\n.jsonEditorContainer .collapse.up {\n  transition: transform 0.2s ease;\n  transform: rotate(360deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
